module.exports = __webpack_public_path__ + "static/media/junk-is-no-good-baby.ce8e07bf.txt";